import {useGetBiotwinSharesQuery} from '../../../app/services/biotwinShareApi';
import {useSession} from '../../auth/hooks/useSession';
import type {Biotwin} from '../../biotwin/types';
import {BiotwinSharePrivilege, BiotwinShareStatus} from '../types';

export const useBiotwinShare = () => {
  const session = useSession();
  const {data: biotwinShares = []} = useGetBiotwinSharesQuery();

  return {
    canWrite: (biotwin: Biotwin) =>
      biotwinShares.some(
        (biotwinShare) =>
          biotwinShare.biotypeId === biotwin.id &&
          biotwinShare.privilege === BiotwinSharePrivilege.Write &&
          biotwinShare.status === BiotwinShareStatus.Accepted,
      ),
    getBiotwinShares: (biotwin: Biotwin) =>
      biotwinShares.filter((biotwinShare) => biotwinShare.biotypeId === biotwin.id),
    isIncoming: (biotwin: Biotwin) =>
      biotwinShares.some(
        (biotwinShare) => biotwinShare.biotypeId === biotwin.id && biotwinShare.ownerId !== Number(session?.id),
      ),
    isOutgoing: (biotwin: Biotwin) =>
      biotwinShares.some(
        (biotwinShare) => biotwinShare.biotypeId === biotwin.id && biotwinShare.ownerId === Number(session?.id),
      ),
    isPending: (biotwin: Biotwin) =>
      biotwinShares.some(
        (biotwinShare) => biotwinShare.biotypeId === biotwin.id && biotwinShare.status === BiotwinShareStatus.Pending,
      ),
    isShared: (biotwin: Biotwin) => biotwinShares.some((biotwinShare) => biotwinShare.biotypeId === biotwin.id),
  };
};
